import springApi, { getDomain } from '../../services/springApi'

export const getOrderInvoices = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/order_invoices', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getOrderInvoice = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/order_invoices/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeOrderInvoice = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/order_invoices', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateOrderInvoice = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/order_invoices/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteOrderInvoice = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/order_invoices/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchOrderInvoices = async (name, token) => (
	fetch( getDomain()+`/order_invoices?filter[name]=${name}&filter[active]=1`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(order_invoice => ({
				label: order_invoice.fullname,
				value: order_invoice.id,
			})),
		)
)